import { render, staticRenderFns } from "./CarouselTab.vue?vue&type=template&id=fe6e1cbe&"
import script from "./CarouselTab.vue?vue&type=script&lang=js&"
export * from "./CarouselTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports